import $ from 'jquery';
export const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

// URL接頭辞（本番は /bunjo、ローカル・ステージングは空文字）
// 本番は /bunjo 配下で配信される。JSが自前で組むURLは route()/asset() を通らないため、
// Blade から渡した接頭辞（SITE_URL_PREFIX）を自分で足す必要がある。
// 足さないと /api/... が /bunjo の外＝コーポレートサイト（WordPress）へ飛んで404になる。
// ※PHP側の App\Helpers\Site::withUrlPrefix() と対になる処理
// ※meta が無いページ（管理画面など）でも落ちないよう、既定は空文字にする
export const urlPrefix = document.querySelector('meta[name="url-prefix"]')?.getAttribute('content') ?? '';
export const withUrlPrefix = (path) => `${urlPrefix}${path}`;

export const requestFetch = async (path, type = "GET", data = null, params = {}, mode = 'json') => {
    const send = Object.assign({}, params, {
        method: type == "GET" ? "GET" : "POST",
        credentials: 'same-origin',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        }
    })
    if (mode == "json") {
        send.headers = {
            ...send.headers,
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': csrfToken,
        }
    }

    const createBody = (data, type, mode = "json") => {
        if (mode == "json") {
            if (type == "PUT" || type == "PATCH" || type == "DELETE") {
                data._method = type;
            }
            return JSON.stringify(data)
        } else {
            let formData = new FormData()
            for (let key in data) {
                if (Array.isArray(data[key])) {
                    data[key].forEach(entry => {
                        formData.append(key + '[]', entry)
                    })
                } else {
                    formData.append(key, data[key])
                }
            }
            if (type == "PUT" || type == "PATCH" || type == "DELETE") {
                formData.append("_method", type);
            }
            return formData
        }
    }

    switch (type) {
        case 'GET':
            if (data) {
                let bodyStringify = stringify(data)
                path = `${path}?${bodyStringify}`
            }
            break
        default: {
            const body = createBody(data, type, mode)
            if (type == "PUT" || type == "PATCH" || type == "DELETE") {
                data._method = type;
            }
            Object.assign(send, { body })
        }
    }

    const resp = await fetch(path, send)
    .catch(err => {
        throw new Error(err)
    })
    const respData = await resp.json()
    return {
        ok: resp.ok,
        status: resp.status,
        data: respData,
    }
}

// PC判定
export const isPc = () => {
    return window.matchMedia('(min-width: 768px)').matches;
}

// ゼロ埋め
export const zeroPadding = (num, len = 2) => {
	return ( Array(len).join('0') + num ).slice( -len );
}

// ログインチェック
export const authCheck = () => {
    const authId = document.querySelector('meta[name="auth_id"]').getAttribute('content');
    return authId === '' ? false : authId;
}

export const numberFormat = (num) => {
    return Number(num).toLocaleString();
}

// カウントアップアニメーション
export const countUpAction = (obj, fixCount) => {
    if(fixCount === 0) {
        obj.dataset.hide = '';
    }else{
        delete obj.dataset.hide;
    }
    $(obj).animate({
        Counter: fixCount
    }, {
        duration: 300,
        easing: 'swing',
        step: (now, e) => {
            $(e.elem).text(Math.ceil(now));
        }
    });
}
